import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {
  ChildrenCell,
  ChildrenCellProps,
} from '../../../../../libs/shared/ui/src/components/tables/cells/childrenCell';
import {StyledTextCellValueDiv as StyledTextCellValueDivBase} from '../../../../../libs/shared/ui/src/components/tables/cells/textCell';

/*
 * Props.
 */

type CustomCellProps = ChildrenCellProps;

/*
 * Styles.
 */

const StyledTextCellValueDiv = styled(StyledTextCellValueDivBase)`
  flex: 1;
`;

const StyledChildrenWrapperDiv = styled.div`
  margin: 0 12px;
`;

/*
 * Component.
 */

export const CustomCell: FC<PropsWithChildren<CustomCellProps>> = (props) => {
  const {
    isSelected,
    isHovering,
    isLoading,
    size,
    settings,
    index,
    value,
    shouldShowStickyGradient,
    shouldRemoveTopBorderRadius,
    shouldRemoveBottomBorderRadius,
    children,
  } = props;

  return (
    <ChildrenCell
      isSelected={isSelected}
      isHovering={isHovering}
      isLoading={isLoading}
      size={size}
      settings={settings}
      index={index}
      value={value}
      shouldShowStickyGradient={shouldShowStickyGradient}
      shouldRemoveTopBorderRadius={shouldRemoveTopBorderRadius}
      shouldRemoveBottomBorderRadius={shouldRemoveBottomBorderRadius}
    >
      <StyledTextCellValueDiv $isSelected={Boolean(isSelected)}>
        <StyledChildrenWrapperDiv>{children}</StyledChildrenWrapperDiv>
      </StyledTextCellValueDiv>
    </ChildrenCell>
  );
};
